import React, { useState } from "react";
import AssociatePhysician from "../physicianInfo/associatePhysician";
import styles from "../physicianTab/AssociationClinic.module.scss";
import { Button, Col, Row, Dropdown } from "react-bootstrap";
import icon from "../../../../images/logo.png";
import { FaPencilAlt } from "react-icons/fa";
import { FaTrashCan } from "react-icons/fa6";
import { BsThreeDotsVertical } from "react-icons/bs";

const AssociationClinic = ({
  physicianInfo,
  handleAssociateClinic,
  handleSelectChange,
  formData,
  modalVisible,
  setModalVisible,
  allClinicList,
  associateModal,
  handleDisassociateClinic,
  editPhysicianFee,
  selectedAction,
  setSelectedAction,
}) => {
  const [selectedClinic, setSelectedClinic] = useState(null);
  return (
    <>
      <div className={styles.clinicDiv}>
        <div className={styles.clinicName}>
          {physicianInfo?.asociatedClinic?.map((clinic, i) => (
            <>
              <div
                key={i}
                className={`${styles.clinicNameIconDiv} ${
                  selectedClinic === clinic ? styles.activeClinic : ""
                }`}
                onClick={() => setSelectedClinic(clinic)}
              >
                <img src={icon} alt="" />
                <Button aria-label="Close" className=" fs-14" key={i}>
                  <span>{clinic?.clinicId?.clinicName}</span>
                </Button>

                <div>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant=""
                      as="div"
                      className="btn-link i-false"
                    >
                      <BsThreeDotsVertical className={styles.dot} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => editPhysicianFee(physicianInfo)}
                      >
                        <FaPencilAlt size={14} className="me-1 text-primary" />
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDisassociateClinic(clinic?.clinicId?._id);
                        }}
                      >
                        <FaTrashCan size={14} className="me-1 text-danger" />
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>

      <Row className={styles.associationRow}>
        <Col md={6}>
          <div className={styles.associationDiv}>
            <div className={styles.associationSubdiv}>
              <h5> Consultation Fee :</h5>
              <p>
                {physicianInfo?.asociatedClinic &&
                  physicianInfo?.asociatedClinic[0]?.regularFees}
              </p>
            </div>
            <div className={styles.associationSubdiv}>
              <h5> Follw-Up Consultation Fee :</h5>
              <p>
                {physicianInfo?.asociatedClinic &&
                  physicianInfo?.asociatedClinic[0]?.followupFees}
              </p>
            </div>
            <div className={styles.associationSubdiv}>
              <h5> Emergency Consultation Fee :</h5>
              <p>
                {physicianInfo?.asociatedClinic &&
                  physicianInfo?.asociatedClinic[0]?.emergencyFees}
              </p>
            </div>
          </div>
        </Col>
        <Col md={6}>
          <div className={styles.associationDiv}>
            <div className={styles.associationSubdiv}>
              <h5> Consultation Fee (Video) :</h5>
              <p>
                {physicianInfo?.asociatedClinic &&
                  physicianInfo?.asociatedClinic[0]?.videConsultationFees}
              </p>
            </div>
            <div className={styles.associationSubdiv}>
              <h5> Establishment Fee :</h5>
              <p>
                {physicianInfo?.asociatedClinic &&
                  physicianInfo?.asociatedClinic[0]?.establishmentFees}
              </p>
            </div>
          </div>
        </Col>
      </Row>
      <div className={styles.associationMainDiv}></div>

      <AssociatePhysician
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        clinicList={allClinicList}
        formData={formData}
        handleSelectChange={handleSelectChange}
        handleAssociateClinic={handleAssociateClinic}
        selectedAction={selectedAction}
        setSelectedAction={setSelectedAction}
      />
    </>
  );
};

export default AssociationClinic;
